import { Component, OnInit } from '@angular/core';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { BehalfOfService } from 'src/app/services/behalfOf/behalf-of.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { customerInterface } from 'src/app/util/interfaces/customer';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { genericFormInterface } from 'src/app/util/interfaces/genericForm';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { OutOfOfficeService } from './service/out-of-office.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ShkDate } from 'shk-date';
import { GenericFormGenModule } from 'src/app/page_component_item/generic-form-gen/generic-form-gen.module';
import { InputWithAutocompleteModule } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.module';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { CommonModule } from '@angular/common';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	standalone: true,
	imports: [CommonModule, GenericFormGenModule, InputWithAutocompleteModule, DotBounceLoadingEffectModule],
	selector: 'pcp-out-of-office',
	templateUrl: './out-of-office.component.html',
	styleUrl: './out-of-office.component.scss',
})
export class OutOfOfficeComponent implements OnInit {
	labels: LabelsInterface = {
		lbl_ausencia_temporaria: '',
		lbl_substituto_responsavel: '',
		lbl_geral_pesquisar: '',
		lbl_buscar_usuarios: '',
		lbl_geral_agendar: '',
		lbl_cancelar_agendamento: '',
		lbl_atualizar_agendamento: '',
		lbl_preencher_data_inicial_final_responsavel_ausencia: '',
		lbl_preencha_data_inicial_final: '',
		lbl_selecione_usuario_lista: '',
		lbl_data_inicial_nao_depois_data_final: '',
		lbl_salvo_com_sucesso: '',
		lbl_removido_com_sucesso: '',
	};

	dictionaryForm = {};
	outOfOfficeForm: genericFormInterface[] = [
		{
			name: 'startDate',
			label: 'lbl_geral_data_inicial',
			inputType: 'date',
			values: [],
		},
		{
			name: 'endDate',
			label: 'lbl_geral_data_final',
			inputType: 'date',
			values: [],
		},
	];

	behalfOfForm: genericFormInterface[] = [
		{
			name: 'name',
			label: 'lbl_geral_nome',
			inputType: 'string',
			values: [],
		},
		{
			name: 'email',
			label: 'lbl_geral_email',
			inputType: 'string',
			values: [],
		},
		{
			name: 'customer',
			label: 'lbl_geral_cliente',
			inputType: 'select',
			values: [],
			items: [],
		},
	];

	constructor(
		private LabelsService: LabelsService,
		private ProfileService: ProfileService,
		private BehalfOfService: BehalfOfService,
		private OutOfOfficeService: OutOfOfficeService,
		private NotificationService: NotificationService
	) {}

	availableCustomers: customerInterface[] = [];
	allowedBehalfOfUsers: enduserInterface[] = [];
	allowedBehalfOfUsersIAC: iacOptionInterface[] = [];
	selectedBehalfOfUser: enduserInterface = { fullName: '', email: '' };
	searchInputText = '';

	isLoadingLabels = true;
	isLoadingData = true;
	isLoadingAvailableCustomers = false;
	isLoadingBehalfOf = false;
	isSavingOutOfOffice = false;
	isRemovingOutOfOffice = false;

	existPreviousSchedule = false;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		for (const formItem of this.behalfOfForm) {
			this.dictionaryForm[formItem.name] = formItem;
		}
		for (const formItem of this.outOfOfficeForm) {
			this.dictionaryForm[formItem.name] = formItem;
		}

		this.ProfileService.getAvailableCustomers().subscribe((availableCustomers) => {
			this.availableCustomers = availableCustomers;
			this.isLoadingAvailableCustomers = false;

			let hasActualCustomer = false;
			for (const customer of this.availableCustomers) {
				const customerItem: genericFormInterface = {
					name: customer.customer,
					label: customer.customer,
					values: [customer.id],
					value: customer.id,
					selected: false,
				};
				this.behalfOfForm.at(-1).items.push(customerItem);
				if (this.ProfileService.userData().idCustomer.toString() === customer.id.toString()) {
					hasActualCustomer = true;
					customerItem.selected = true;
					this.behalfOfForm.at(-1).values.push(customerItem.values[0]);
				}
			}

			this.isLoadingAvailableCustomers = false;
		});

		this.isLoadingData = true;
		this.OutOfOfficeService.getMyOutOfOfficeData().subscribe((outofofficeRes) => {
			outofofficeRes = outofofficeRes[0];
			this.dictionaryForm['startDate'].values[0] = new ShkDate(new Date(outofofficeRes.startDate)).getDate();
			this.dictionaryForm['endDate'].values[0] = new ShkDate(new Date(outofofficeRes.endDate)).getDate();
			this.selectedBehalfOfUser.fullName = outofofficeRes.nameResponsible;
			this.selectedBehalfOfUser.id = outofofficeRes.idResponsible;
			this.selectedBehalfOfUser.email = outofofficeRes.emailResponsible;
			if (this.selectedBehalfOfUser.email) this.existPreviousSchedule = true;
			this.isLoadingData = false;
		});
	}

	getAllowedBehalfOfUsers(userName: string, userEmail: string, idCustomer: string): void {
		this.isLoadingBehalfOf = true;

		if (userName && userName.trim() !== '') {
			this.searchInputText = userName;
		} else if (userEmail && userEmail.trim() !== '') {
			this.searchInputText = userEmail;
		}

		this.BehalfOfService.getAllowedBehalfOfUsers(userName, userEmail, idCustomer).subscribe(
			(behalfOfUsers) => {
				this.allowedBehalfOfUsers = [];
				this.allowedBehalfOfUsersIAC = [];
				this.allowedBehalfOfUsers = behalfOfUsers;
				for (const user of this.allowedBehalfOfUsers) {
					const behalfOfIAC: iacOptionInterface = {
						name: user.fullName,
						secondName: user.email,
						value: user.email,
						commonGroup: user.email,
					};
					this.allowedBehalfOfUsersIAC.push(behalfOfIAC);
				}

				this.isLoadingBehalfOf = false;
			},
			() => {
				this.isLoadingBehalfOf = false;
			}
		);
	}

	isFormValidated(): boolean {
		if (
			!this.dictionaryForm['startDate'].values[0] ||
			this.dictionaryForm['startDate'].values[0] == undefined ||
			isNaN(new Date(this.dictionaryForm['startDate'].values[0]).getTime()) ||
			!this.dictionaryForm['endDate'].values[0] ||
			this.dictionaryForm['endDate'].values[0] == undefined ||
			isNaN(new Date(this.dictionaryForm['endDate'].values[0]).getTime())
		) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_data_inicial_final);
			return false;
		}
		if (new Date(this.dictionaryForm['startDate'].values[0]) > new Date(this.dictionaryForm['endDate'].values[0])) {
			this.NotificationService.setNotificationMessage(this.labels.lbl_data_inicial_nao_depois_data_final);
			return false;
		}
		if (this.selectedBehalfOfUser.email == '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_selecione_usuario_lista);
			return false;
		}

		return true;
	}

	toSchedule(): void {
		if (this.isSavingOutOfOffice || !this.isFormValidated()) return;

		this.isSavingOutOfOffice = true;
		this.OutOfOfficeService.setMyOutOfOffice(
			this.dictionaryForm['startDate'].values[0],
			this.dictionaryForm['endDate'].values[0],
			this.selectedBehalfOfUser.email
		).subscribe(
			(res) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.existPreviousSchedule = true;
				this.isSavingOutOfOffice = false;
			},
			() => {
				this.isSavingOutOfOffice = false;
			}
		);
	}

	updateSchedule(): void {
		if (this.isSavingOutOfOffice || this.isRemovingOutOfOffice || !this.isFormValidated()) return;

		this.isSavingOutOfOffice = true;
		this.OutOfOfficeService.updateMyOutOfOffice(
			this.dictionaryForm['startDate'].values[0],
			this.dictionaryForm['endDate'].values[0],
			this.selectedBehalfOfUser.email
		).subscribe(
			(res) => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
				this.isSavingOutOfOffice = false;
			},
			() => {
				this.isSavingOutOfOffice = false;
			}
		);
	}

	removeSchedule(): void {
		if (this.isSavingOutOfOffice || this.isRemovingOutOfOffice) return;
		this.isRemovingOutOfOffice = true;
		this.OutOfOfficeService.removeSchedule().subscribe(() => {
			this.NotificationService.setNotificationMessage(this.labels.lbl_removido_com_sucesso);
			this.existPreviousSchedule = false;
		});
	}
}
